import { Constant } from "../../../constants/constant";
import LangKR from "../../../../assets/i18n/icons/south-korea.png";
import LangEN from "../../../../assets/i18n/icons/kingdom.png";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../store/hook";
import { changeMultiLang } from "../../../reducers/multiLangSilce";

export default function MutilLanguage() {
  const [lang, setLang] = useState("");
  const { t, i18n } = useTranslation();
  const dispatch =  useAppDispatch();

  function handleChange(lang: string) {
    localStorage.setItem(Constant.LANGUAGE, lang);
    setLang(lang);
    i18n.changeLanguage(lang);
    dispatch(changeMultiLang(lang));
  }

  useEffect(() => {
    setLang(localStorage.getItem(Constant.LANGUAGE) || Constant.SOUTH_KOREA);
  }, []);

  return (
    <>
      <a href="#" className="d-flex align-items-center waves-effect waves-light dropdown-toggle btn-outline no-border" data-bs-toggle="dropdown" title="Notifications"
        style={{justifyContent: "center", borderRadius: "50%", backgroundColor: "white", padding: "0px"}}
      >
        <img id="header-lang-img" src={lang == Constant.ENGLISH ? LangEN : LangKR} alt="Header Language" height="30" className="rounded" />
      </a>
      <ul className="dropdown-menu animated bounceIn">
        <li>
          <a className="dropdown-item notify-item language py-2 cus-cursor" data-lang="en" title="English" onClick={() => handleChange(Constant.ENGLISH)}>
            <img src={require("../../../../assets/images/flags/kingdom.png")} alt="user-image" className="me-2 rounded" height="25" />
            <span className="align-middle">English</span>
          </a>
        </li>
        <li>
          <a className="dropdown-item notify-item language cus-cursor" data-lang="sp" title="South Korea" onClick={() => handleChange(Constant.SOUTH_KOREA)}>
            <img src={require("../../../../assets/images/flags/south-korea.png")} alt="user-image" className="me-2 rounded" height="25" />
            <span className="align-middle">South Korea</span>
          </a>
        </li>
      </ul>
    </>
  );
}
